import { render, staticRenderFns } from "./prices.vue?vue&type=template&id=a1a1b486"
import script from "./prices.vue?vue&type=script&lang=js"
export * from "./prices.vue?vue&type=script&lang=js"
import style0 from "./prices.vue?vue&type=style&index=0&id=a1a1b486&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AnimatedNumber: require('/app/components/animatedNumber.vue').default})
